// extracted by mini-css-extract-plugin
export var Footer = "Footer-module--Footer--1-t5n";
export var Footer__social = "Footer-module--Footer__social--37wdz";